<script>
  import { onDestroy } from "svelte";
  import { lang } from "../lib/stores";
  let selectedLang;
  const unsubscribe = lang.subscribe((value) => selectedLang = value);
  onDestroy(unsubscribe);
</script>
<section class="mapMilano">
  <div class="mapMilano-details">
    <blockquote>
      <p>
        Mi odio e mi amo, come <em>Milano</em><br />
        Come fai te
      </p>
      <p><small>Milano, Album, 2017</small></p>
    </blockquote>
    <div class="p">
      <p>
        {#if selectedLang === 'it'}
          Fondata secondo la leggenda dal re celtico <em>Belloveso</em> nel 600
          Avanti Cristo, conquistata dai romani dopo circa tre secoli, divenuta
          capitale dell'impero durante il regno di <em>Diocleziano</em>, distrutta
          da <em>Attila</em>, conquistata dai <em>Longobardi</em>, poi libero
          comune e signoria, caduta sotto la dominazione francese e poi spagnola,
          ereditata dalla corona austriaca, capitale del Regno d'Italia sotto
          <em>Napoleone</em>
          e, dopo la restaurazione, sede di grandi rivolte popolari contro la
          dominazione asburgica, luogo di nascita del <em>fascismo</em> e
          <em>medaglia d'oro della Resistenza</em>
          (tramite <em>Radio Milano Libera</em> il partigiano Sandro Pertini
          diffuse il famoso comunicato "<a
            href="https://www.youtube.com/watch?v=QRsjGQqvu88"
            target="_blank">Arrendersi o morire</a
          >"), epicentro degli
          <a href="https://it.wikipedia.org/wiki/Anni_di_piombo" target="_blank"
            >anni di piombo</a
          >
          e di
          <a href="https://it.wikipedia.org/wiki/Mani_pulite" target="_blank"
            >mani pulite</a
          >, Milano nella sua storia ne ha viste di tutti i colori. Al giorno
          d'oggi, <em>Milano</em>
          è la sede della
          <a href="https://it.wikipedia.org/wiki/Lega_Nord" target="_blank"
            >Lega Nord</a
          >
          e la casa del
          <em>musicista di seconda generazione più famoso in Italia</em>
          (oltre che di tanti, tanti altri).
        {:else}
          Legend has it that Milan was founded by the Celtic king <em>Belloveso</em> in 600 BCE,
          conquered by the Romans about three centuries later, and became the capital of
          the empire during the reign of <em>Diocletian</em>. It was destroyed by <em>Attila</em>, conquered
          by the <em>Lombards</em>, later becoming a free commune and a lordship, then fell under
          French and Spanish rule, was inherited by the Austrian crown, became the capital
          of the Kingdom of Italy under <em>Napoleon</em>, and, after the Restoration, was a center
          of major popular uprisings against Habsburg domination.<br />
          Milan was also the birthplace of <em>fascism</em> and earned the <em>Gold Medal of the Resistance</em>.
          Through Radio Milano Libera, the partisan Sandro Pertini delivered the famous message "<a
          href="https://www.youtube.com/watch?v=QRsjGQqvu88"
          target="_blank">Surrender or die</a>". It became
          the epicenter of the <a href="https://it.wikipedia.org/wiki/Anni_di_piombo" target="_blank"
          >Years of Lead</a> and the <a href="https://it.wikipedia.org/wiki/Mani_pulite" target="_blank"
          >Mani Pulite</a> investigation.<br />
          Over its history, Milan has seen it all. Today, Milan is home to the <a href="https://it.wikipedia.org/wiki/Lega_Nord"
          target="_blank">Lega Nord</a> and the country's most
          famous second-generation musician (along with many, many others).
        {/if}
      </p>
    </div>
    <blockquote>
      <p>
        Il mio non è rap, è un raptus<br />
        <em>A Milano mi senti dal bus</em><br />
        Sto sopra i tetti, 9attous
      </p>
      <p><small>Ninna Nanna, Album, 2017</small></p>
    </blockquote>
    <div class="p">
      <p>
        {#if selectedLang === 'it'}
          Ghali cita <em>Milano</em>{" "}<em class="data">8</em> volte in
          <em class="data">3</em>
          differenti brani: <em>Ninna Nanna</em>, <em>Milano</em> (Album, 2017), e
          <em>Come Milano</em>
          (Lunga Vita a Sto, 2017).
        {:else}
          Ghali mentions <em>Milan </em> <em class="data">8</em> times in
          <em class="data">3</em> 
          different songs: <em>Ninna Nanna</em> , <em>Milano</em> (Album, 2017), and
          <em>Come Milano</em> 
          (Lunga Vita a Sto, 2017).
        {/if}
      </p>
    </div>
  </div>
</section>

<style>
  .mapMilano {
    display: block;
  }
</style>
